import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  EditButton,
  DeleteButton,
  CreateButton,
  TopToolbar,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CustomEmptyState } from '../../components/CustomEmptyState';

const StatusField = () => {
  const record = useRecordContext();
  if (!record?.status) {
    return null;
  }

  const getColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'success';
      case 'expired':
        return 'error';
      case 'suspended':
        return 'warning';
      default:
        return 'default';
    }
  };

  return <Chip label={record.status} color={getColor(record.status)} size="small" />;
};

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export const DriverLicenseList = () => {
  const navigate = useNavigate();

  return (
    <List
      perPage={25}
      sort={{ field: 'id', order: 'DESC' }}
      actions={<ListActions />}
      empty={
        <CustomEmptyState
          resource="driver-licenses"
          onAction={() => navigate('/driver-licenses/create')}
        />
      }
    >
      <Datagrid>
        <TextField source="id" />
        <ReferenceField source="driverId" reference="drivers" link="show">
          <ReferenceField source="userId" reference="users" link={false}>
            <TextField source="name" />
          </ReferenceField>
        </ReferenceField>
        <ReferenceField source="licenseTypeId" reference="license-types" link={false}>
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="licenseTypeId" reference="license-types" link={false}>
          <TextField source="province" />
        </ReferenceField>
        <TextField source="code" />
        <DateField source="expiry" />
        <StatusField />
        <DateField source="createdAt" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
